<template>
    <path d="m 14.10076,2.464213 v 2.6519265 h 2.56408 L 14.010489,7.7704891 C 12.873764,6.9949685 11.501077,6.5408976 10.02424,6.5408976 c -3.9101817,0 -7.0912767,3.1811421 -7.0912767,7.0911124 0,3.910182 3.1810951,7.091277 7.0912767,7.091277 3.90997,0 7.091028,-3.181095 7.091028,-7.091277 0,-1.476878 -0.454114,-2.849589 -1.229674,-3.9863325 L 18.540027,6.9912437 V 9.555491 h 2.65201 V 2.464213 Z m -4.07652,6.728778 c 2.447593,0 4.439098,1.991378 4.43927,4.439184 0,2.447978 -1.991633,4.43927 -4.43927,4.43927 -2.4479769,0 -4.439267,-1.991462 -4.439267,-4.43927 0,-2.447806 1.9914611,-4.439184 4.439267,-4.439184 z"/>
</template>

<script>
    export default {
        name: 'gender',
    }
</script>



// WEBPACK FOOTER //
// src/components/icon/Gender.vue